/**
 * Fills a workspace `name_format` template with `patient.additional.patient_name` parts.
 * Tokens: `{first_name}`, `{middle_name}`, `{last_name}` (case-sensitive).
 * Missing parts are replaced with an empty string; the template string is otherwise unchanged.
 *
 * If `format` is null, undefined, or only whitespace, returns `""`.
 */
export function formatPatientNameFromTemplate(format, patientName) {
  var _patientName$first, _patientName$middle, _patientName$last;
  if (format == null || !String(format).trim()) {
    return "";
  }
  var first = String((_patientName$first = patientName === null || patientName === void 0 ? void 0 : patientName.first) !== null && _patientName$first !== void 0 ? _patientName$first : "").trim();
  var middle = String((_patientName$middle = patientName === null || patientName === void 0 ? void 0 : patientName.middle) !== null && _patientName$middle !== void 0 ? _patientName$middle : "").trim();
  var last = String((_patientName$last = patientName === null || patientName === void 0 ? void 0 : patientName.last) !== null && _patientName$last !== void 0 ? _patientName$last : "").trim();
  return format.replace(/\{first_name\}/g, first).replace(/\{middle_name\}/g, middle).replace(/\{last_name\}/g, last);
}